export const extractDomain = () => {
  const fullUrl = window.location.href;
  // for work with all browsers
  const url = document.createElement("a");
  url.setAttribute("href", fullUrl);

  if (url.hostname.indexOf("www") === 0) {
    return url.hostname.replace(/(www-sta|www)/, "");
  }
  return url.hostname;
};

export const getExpDateByDays = (numberOfDays: number) => {
  const expDate = new Date();

  expDate.setDate(expDate.getDate() + numberOfDays);
  return expDate;
};
